import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import {
  ShoppingCartService,
  NotificationService,
  CartPrintService,
} from '@app/core/services';
import { MatSort, Sort } from '@angular/material/sort';
import { select, State, Store } from '@ngrx/store';
import { PatientCartActionTypes, AppState } from '@app/core/ngrx';
import { Observable } from 'rxjs';

@Component({
  selector: 'ecp-patient-cart-detail-card',
  templateUrl: './patient-cart-detail-card.component.html',
  styleUrls: ['./patient-cart-detail-card.component.scss'],
})
export class PatientCartDetailCardComponent implements OnInit {
  @Input()
  cart;

  panelDisplay: Array<number> = [];
  @ViewChild('sortSection') sortSection: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  sortedData: Array<any>;

  public cart$: Observable<any>;
  processedImage$: any;
  totalFrames$: any;

  processedImage: any;
  totalFrames: any;
  constructor(
    private shoppingCartService: ShoppingCartService,
    private notificationService: NotificationService,
    private cartPrintService: CartPrintService,
    private state: State<AppState>,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.sortedData = this.cart.frames.slice();

    this.processedImage$ = this.store.pipe(
      select(state => state.patientCart.printState.processedImage),
    );
    this.processedImage$.subscribe(processImage => {
      this.processedImage = processImage;
    });

    this.totalFrames$ = this.store.pipe(
      select(state => state.patientCart.printState.totalFrames),
    );
    this.totalFrames$.subscribe(totalFrames => {
      this.totalFrames = totalFrames;
    });
  }

  deleteCart(cart) {
    this.shoppingCartService.deleteCart(cart.cartId).subscribe(resp => {
      console.log(resp);
      let notificationOptions = {
        title: 'Notification',
        contentHtml: 'Frame cart has been deleted.',
        confirmBtnText: 'Close',
      };
      this.notificationService.error(notificationOptions);
      this.store.dispatch({ type: PatientCartActionTypes.LOAD_PATIENT_CART });
    });
  }

  sortData(sort: Sort): void {
    const data = this.cart.frames.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'smallImageUrl':
          return compare(a.smallImageUrl, b.smallImageUrl, isAsc);
        case 'styleName':
          return compare(a.styleName, b.styleName, isAsc);
        case 'colorDescription':
          return compare(a.colorDescription, b.colorDescription, isAsc);
        case 'eyeSize':
          return compare(
            a.eyeSize + '-' + a.temple,
            b.eyeSize + '-' + b.temple,
            isAsc,
          );
        case 'upc':
          return compare(a.upc, b.upc, isAsc);
        default:
          return 0;
      }
    });
  }

  printCart(cart) {
    let cartArray = [];
    cartArray.push(cart);
    let user = this.state.getValue().user.profile;
    this.cartPrintService.printCart(cartArray, user);
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
